//StatusService.js

import ApiService from '../apiservice';

class StatusService extends ApiService {

    constructor() {
        super('/status');
    }

    getAll() {
        return this.get(`${this.apiurl}/all`);
    }

    getById(id) {
        return this.get(`${this.apiurl}/${id}`);
    }

    getByDescription(description) {
        return this.get(`${this.apiurl}/description/${description}`);
    }
}

export default StatusService;